module.exports = __webpack_public_path__ + "assets/img/18-m.2143ffc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/18-m.jpg
// module id = eOcC
// module chunks = 0